import { ArrowUpRight } from "lucide-react";

export const OpportunityCard = ({ index, name, hint, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={`opportunity-card-${name.toLowerCase().replace(/\s+/g, "-")}`}
    aria-label={`Explore ${name.toLowerCase()} opportunities in the app`}
    className="group relative flex min-h-[170px] flex-col justify-between overflow-hidden border-b border-r border-white/10 p-5 text-left lg:min-h-[210px] lg:p-6"
  >
    <span className="absolute inset-0 origin-bottom scale-y-0 bg-pa-orange transition-transform duration-500 ease-out-expo group-hover:scale-y-100" aria-hidden="true" />
    <span className="relative flex items-start justify-between">
      <span className="font-mono text-[11px] text-pa-dim transition-colors duration-500 group-hover:text-pa-black">{String(index).padStart(2, "0")}</span>
      <ArrowUpRight className="h-5 w-5 text-pa-dim transition-[transform,color] duration-500 ease-out-expo group-hover:rotate-45 group-hover:text-pa-black" aria-hidden="true" />
    </span>
    <span className="relative">
      <span className="block font-display text-[clamp(1.9rem,3vw,2.6rem)] uppercase leading-[0.9] text-pa-ink transition-colors duration-500 group-hover:text-pa-black">{name}</span>
      <span className="mt-2 block text-[13px] text-pa-muted transition-colors duration-500 group-hover:text-pa-black/80">{hint}</span>
    </span>
  </button>
);
